module.exports = __webpack_public_path__ + "static/media/step2of3.d50ed630.svg";